export const fetchLeadPipelineSettings = (__unusedKey, httpClient) => {
  return httpClient.get('leads/v3/settings/pipeline-settings/all');
};